import { useEffect, useState } from 'react';
import axios from 'axios';
import language from '../../variables/language';
import IconConversation from '../../components/icons/IconConversation';
import ConversationProgressElment from './ConversationProgressElement';

const SKELETON_ROW_COUNT = 6;

export default function LastConversationProgress() {
   const lang = language[language.lang];
   const url = '/api/conversationprogress?limit=20';
   const [data, setData] = useState([]);
   const [status, setStatus] = useState('loading');

   useEffect(() => {
      axios.get(url, { withCredentials: true })
         .then(response => setData(response.data))
         .catch(err => console.error(err))
         .finally(() => setStatus('done'));
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   return (
      <div className='last-conversations-container dashboard-component'>
         <div className='header-dahs-elem'>
            <IconConversation style={{ width: 30, height: 30, fill: 'var(--dashboard-header-icon-color)' }} />
            <p className='txt-c'>{lang.latestBotConversations}</p>
         </div>
         <div className='last-conversations scrooll'>
            {status === 'loading' ? (
               Array.from({ length: SKELETON_ROW_COUNT }).map((_, i) => (
                  <div key={i} className='skeleton-block conv-prog-elem-skeleton'></div>
               ))
            ) : data.map((item, index) => <ConversationProgressElment item={item} key={index} />)}
         </div>
      </div>
   );
}
